import { useEffect, useRef } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router';
import { connectSocket } from './net/socket';
import { useRoom } from './stores/room';
import { useSession } from './stores/session';
import { ConnectionBanner } from './ui/ConnectionBanner';
import { SvgDefs } from './ui/Icons';
import { Toasts } from './ui/Toasts';

/** Lleva al jugador a su sala o partida cuando cambia el estado de la sala. */
function useRoomRouting() {
  const room = useRoom((s) => s.room);
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const prevStatus = useRef<string | null>(null);
  const key = room ? `${room.code}|${room.status}|${room.gameId ?? ''}` : 'none';

  useEffect(() => {
    if (!room) {
      prevStatus.current = null;
      return;
    }
    const startedNow = room.status === 'playing' && prevStatus.current !== null && prevStatus.current !== 'playing';
    prevStatus.current = room.status;
    const inRoomArea = pathname === '/' || pathname.startsWith('/sala') || pathname.startsWith('/partida');
    if ((room.status === 'playing' || room.status === 'finished') && room.gameId) {
      if (!pathname.startsWith(`/partida/${room.gameId}`) && (startedNow || inRoomArea)) navigate(`/partida/${room.gameId}`);
    } else if (room.status === 'lobby' && inRoomArea && pathname !== `/sala/${room.code}`) {
      navigate(`/sala/${room.code}`);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [key]);
}

export function Root() {
  const token = useSession((s) => s.token);
  useEffect(() => {
    if (token) connectSocket();
  }, [token]);
  useRoomRouting();
  return (
    <>
      <SvgDefs />
      <Outlet />
      <Toasts />
      <ConnectionBanner />
    </>
  );
}
